import { type FunctionComponent, type ReactNode } from 'react';
import { Provider } from 'react-redux';
import { type PrayerStreamStore } from '../../core/store';

export type ReduxProviderProps = {
  children?: ReactNode;
  store: PrayerStreamStore;
};

export const ReduxProvider: FunctionComponent<ReduxProviderProps> = ({
  children,
  store,
}) => {
  return (
    <Provider
      identityFunctionCheck="always"
      stabilityCheck="always"
      store={store}
    >
      {children}
    </Provider>
  );
};
